import { useState, useEffect, button } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import ComplaintShimmer from './ComplaintShimmer';
import { MetaTags } from 'react-meta-tags';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Badge, Button, Card } from 'reactstrap';

import 'react-datepicker/dist/react-datepicker.css';

//Import Flatepicker
import 'flatpickr/dist/themes/material_blue.css';

import Flatpickr from 'react-flatpickr';

import { Col, Container, Row, FormGroup, Label, CardBody } from 'reactstrap';
import { DashBreadcrumb } from '../../../../components/Common/Breadcrumb';
import { TextArea } from 'semantic-ui-react';
import { getComplaintDetails, updateComplaintStatus } from '../actions/action';
import toast, { Toaster } from 'react-hot-toast';
import { tr } from 'date-fns/locale';

const ComplaintDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const users = JSON.parse(localStorage?.getItem('authUser'));

    useEffect(() => {
      getComplaintDetails({
        params: {
          complaint_no:id,
        },

        dispatch,

      });
    }, [id]);
    const { complaintDetail = [], isLoading } = useSelector((state) => state.complaints);
    const complaintDetailData = complaintDetail?.data || [];

const styles = {
  bgGreen: {
    backgroundColor: '#13af1bff',
  },
  bgGreenLight: {
    backgroundColor: '#a2ffa7ff',
  },
  bgGray: {
    backgroundColor: '#a0a0a0ff',
  },
  bgGrayLight: {
    backgroundColor: '#d3d3d3ff',
  },
  bgRedLight: {
    backgroundColor: '#faadb3ff',
  },
  textGray : {
    color: '#6c757d',
  },
  textGreen : {
    color: '#13af1bff',
  },
  textGreenLight : {
    color: '#a2ffa7ff',
  },
  textRed : {
    color: '#dc3545', 
  },
};

  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [comment, setComment] = useState('');
  const [statusError, setStatusError] = useState('');
  const [commentError, setCommentError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (isLoading) {
    return <ComplaintShimmer />;
  }

  console.log('complaintDetailData', complaintDetailData);

  const images = Array.isArray(complaintDetailData?.images) ? complaintDetailData.images : [];
  const skus = Array.isArray(complaintDetailData?.sku) ? complaintDetailData.sku : [];
  const productInfo = Array.isArray(complaintDetailData?.productInfo) ? complaintDetailData.productInfo : [];
  const remarksOptions = Array.isArray(complaintDetailData?.nextStatus) ? complaintDetailData.nextStatus : [];
  const isRated = complaintDetailData?.isRated;
  const ratingInfo = complaintDetailData?.ratingInfo;


  const openLightbox = (idx) => {
    setLightboxIndex(idx);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => setIsLightboxOpen(false);

  const moveNext = () => setLightboxIndex((lightboxIndex + 1) % images.length);
  const movePrev = () => setLightboxIndex((lightboxIndex + images.length - 1) % images.length);

  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title>Complaint Detail</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <DashBreadcrumb
            title="Complaints"
            breadcrumbItem="Complaint Detail"
          />
          <Row className="align-items-start border-bottom border-top px-3 py-4 mb-0 row bg-light border-secondary-subtle">
            <Col md="9" className="border-3 border-end py-4">
              <Row>
                <Col md="9">
                  <div className="d-flex align-items-center gap-3">
                    {(() => {
                      const progress = Math.round(Number(complaintDetailData?.progress) || 0);
                      const progressClass = `progressCircle p${progress}${progress > 50 ? ' over50' : ''}`;
                      return (
                        <div className={progressClass}>
                          <span>{progress}%</span>
                          <div className="leftHalfClipper">
                            <div className="first50Bar"></div>
                            <div className="valueBar"></div>
                          </div>
                        </div>
                      );
                    })()}
                    <div className="d-flex flex-column gap-2">
                      <h5 className="mb-1 fw-semibold">
                        Service Request - {complaintDetailData?.complaintCategory}{complaintDetailData?.complaintSubcategory ? ` - ${complaintDetailData.complaintSubcategory}` : ''}
                      </h5>
                      <p className="m-0">Ticket: {complaintDetailData?.complaintNo}</p>
                      {complaintDetailData?.orderNo && (
                        <p className="m-0">Order No: {complaintDetailData?.orderNo}</p>
                      )}
                      <p className="text-muted m-0">
                        Created on {complaintDetailData?.createdAt}
                      </p>
                      <div className="d-flex flex-row gap-2 align-items-center">
                        Status :
                        <span className={`badge ${complaintDetailData?.statusText === 'Rejected' ? 'bg-soft-danger text-danger' : 'bg-soft-success text-success'} rounded-pill fw-semibold d-flex align-items-center gap-1 p-1`}>
                          <span
                            className={`badge border ${complaintDetailData?.statusText === 'Rejected' ? 'border-danger text-danger' : 'border-success text-success'} rounded-pill fw-semibold p-0 d-flex flex-column align-items-center justify-content-center`}
                            style={{ width: 12, height: 12 }}
                          >
                            <span
                              className={`badge bg-${complaintDetailData?.statusText === 'Rejected' ? 'danger text-danger' : 'success text-success'} rounded-pill fw-semibold d-block p-0`}
                              style={{ width: 6, height: 6 }}
                            ></span>
                          </span>
                          {complaintDetailData?.statusText}
                        </span>
                      </div>
                      {complaintDetailData?.resolutionDescription && (
                        <div className="d-flex flex-row gap-2 align-items-center mt-1">
                          Resolution :
                          <span className="badge bg-soft-info text-info rounded-pill fw-semibold">
                            {complaintDetailData.resolutionDescription === 'pickup_refund'
                              ? 'Pick Up Refund'
                              : complaintDetailData.resolutionDescription}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md="3" className="py-4">
              <div className="d-flex flex-column gap-2 px-4">
                <h5 className="mb-2 fw-semibold">Customer Details</h5>
                <div className="d-flex flex-column gap-2">
                  <p className="m-0 text-muted">{complaintDetailData?.customerName}</p>
                  <p className="m-0 text-muted">{complaintDetailData?.mobile}</p>
                  <p className="m-0 text-muted">{complaintDetailData?.email}</p>
                </div>
              </div>

              {/* <Row>
                <Col>
                  <FormGroup className="mb-4 p-0 position-relative">
                    <Label
                      className="text-muted small position-absolute p-1 bg-white"
                      style={{ zIndex: 1, top: '-10px', left: '10px' }}
                    >
                      Service Request
                    </Label>
                    <Card className="border-1 border-dark bg-white">
                      <CardBody className="py-3 px-3">
                        Product Complaints
                      </CardBody>
                    </Card>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="mb-4 p-0 position-relative">
                    <Label
                      className="text-muted small position-absolute p-1 bg-white"
                      style={{ zIndex: 1, top: '-10px', left: '10px' }}
                    >
                      Type
                    </Label>
                    <Card className="border-1 border-dark bg-white">
                      <CardBody className="py-3 px-3">Mechanism Issue</CardBody>
                    </Card>
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup className="m-0 p-0 position-relative">
                    <Label
                      className="text-muted small position-absolute p-1 bg-white"
                      style={{ zIndex: 1, top: '-10px', left: '10px' }}
                    >
                      Remarks
                    </Label>
                    <Card className="border-1 border-dark bg-white mb-0">
                      <CardBody className="py-3 px-3">tersaaaatta</CardBody>
                    </Card>
                  </FormGroup>
                </Col>
              </Row> */}
            </Col>
          </Row>

          <Row className="px-3 py-4">
            {/* Left Panel */}
            <Col md="3" className="border-2 border-end">
              <div className="p-4">
                <h4 className="fw-semibold mb-3">Complaint Status</h4>

                <div className="ps-5 d-flex flex-column">
                  {/* {steps.map((step, i) => (
                    <div key={i} className="position-relative">
                      <div
                        className="position-absolute rounded-circle d-flex align-items-center justify-content-center text-white bg-soft-success"
                        style={{
                          width: '22px',
                          height: '22px',
                          left: '-10px',
                          top: '-3px',
                        }}
                      >
                        <div className="position-absolute rounded-circle d-flex align-items-center justify-content-center text-white bg-success p-1">
                          <img
                            src="https://assets.danubehome.com/media/assets/svg-v2/tick.svg"
                            width="8"
                            height="8"
                            alt=""
                          />
                        </div>
                      </div>
                      <div
                        className="ps-4 pb-4"
                        style={{ borderLeft: '2px solid #92cc7c' }}
                      >
                        <strong className={step.closed ? 'text-success' : ''}>
                          {step.title}
                        </strong>
                        <p className="mb-0 text-muted small">{step.desc}</p>
                        <small className="text-muted">
                          Created Nov 06, 2025
                        </small>
                      </div>
                    </div>
                  ))} */}
                    {complaintDetailData?.statusHistory?.length > 0 ? (
                      complaintDetailData.statusHistory.map((step, idx) => {
                        // Use existing UI classes for each step
                        let stepClass = styles.trackView;
                        if (step?.identification === 'current' && step?.label !== 'Rejected') stepClass += ' ' + styles.Active;
                        else if (step?.label === 'Rejected') stepClass += ' ' + styles.dropped;
                        else if (step?.label === 'Completed') stepClass += ' ' + styles.Active;
                        else if (step?.identification === 'previous') stepClass += ' ' + styles.completed;
                        else stepClass += ' ' + styles.pending;

                        // Icon selection
                        let iconSrc = 'https://assets.danubehome.com/media/assets/svg-v2/tick.svg';
                        if (step?.label?.status === 'Rejected') {
                          iconSrc = 'https://assets.danubehome.com/media/assets/svg-v2/closeIconV1.svg';
                        }

                        const isLast = idx === complaintDetailData.statusHistory.length - 1;

                        return (
                            <div key={idx} className="position-relative">
                              <div
                                className={`position-absolute rounded-circle d-flex align-items-center justify-content-center text-white ${step?.identification === 'current' && step?.label !== 'Rejected' ? 'bg-soft-success' : ''}`}
                                style={{
                                  width: '22px',
                                  height: '22px',
                                  left: '-10px',
                                  top: '-3px',
                                  backgroundColor:
                                    step?.identification === 'current' && step?.label !== 'Rejected'
                                      ? ''
                                      : step?.identification === 'previous' ?  styles.bgGreenLight.backgroundColor : 
                                      step?.identification === 'current' && step?.label === 'Rejected' ? styles.bgRedLight.backgroundColor : styles.bgGrayLight.backgroundColor
                                      ,
                                }}
                              >
                                <div
                                  className={`position-absolute rounded-circle d-flex align-items-center justify-content-center text-white p-1 ${
                                    step?.identification === 'current' && step?.label === 'Rejected'
                                      ? 'bg-danger'
                                      : step?.identification === 'current' && step?.label !== 'Rejected'
                                      ? 'bg-success'
                                      : ''
                                  }`}
                                  style={{
                                    backgroundColor:
                                      !(step?.identification === 'current' && step?.label === 'Rejected') &&
                                      !(step?.identification === 'current' && step?.label !== 'Rejected')
                                        ?  step?.identification === 'previous' ?  styles.bgGreen.backgroundColor : styles.bgGray.backgroundColor
                                        : undefined,
                                  }}
                                >
                                  <img
                                    src={iconSrc}
                                    width="8"
                                    height="8"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div
                                className="ps-4 pb-4"
                                style={
                                  isLast
                                    ? {}
                                    : {
                                        borderLeft:
                                          step?.identification === 'current' && step?.label === 'Rejected'
                                            ? '2px solid #dc3545' // red for rejected
                                            : step?.identification === 'current' && step?.label !== 'Rejected'
                                            ? '2px solid #92cc7c' // green for current
                                            : step?.identification === 'previous'
                                            ? '2px solid #13af1bff' // darker green for previous
                                            : '2px solid #d3d3d3', // gray for others
                                      }
                                }
                              >
                                <strong style={
                                  step?.identification === 'current' && step?.label === 'Rejected'
                                  ? styles.textRed
                                  : step?.identification === 'current' && step?.label !== 'Rejected'
                                  ? styles.textGreen
                                  : step?.identification === 'previous'
                                  ? styles.textGreenLight
                                  : styles.textGray
                                }>
                                  {step.label}
                                </strong>
                                <p className="mb-0 text-muted small"></p>
                                <small className="text-muted">
                                  {step?.createdAt &&
                                  `Created ${new Date(step.createdAt).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })}`
                                  }
                                </small>
                              </div>
                            </div>
                        );
                       
                    })
                    ) : (
                      <></>
                    )}
                </div>
              </div>
            </Col>

            {/* Center Panel */}
            <Col md="6" className="border-3 border-end">
              <div className="p-4">
                {complaintDetailData?.statusHistory?.length > 0 ? (
                    complaintDetailData.statusHistory.map((step, idx) => {

                      return (
                        <>
                        {step?.remark && (
                      <div className="bg-soft-light p-4 rounded-3 mb-4 border">
                        <div className="d-flex flex-row align-items-center gap-3 border-bottom pb-3 mb-4">
                          <div className="flex-grow-1">
                            <h5 className="mb-1 fw-semibold">{step?.updatedBy}</h5>
                            <p className="text-muted mb-0 small">
                              Created at, {step?.createdAt}
                            </p>
                          </div>
                          <span className="badge rounded-pill px-3 py-2 fw-semibold ms-auto"
                            style={{ backgroundColor: '#fff3e0', color: '#b45309', fontSize: '0.78rem', letterSpacing: '0.3px', border: '1px solid #fcd59c' }}>
                            <i className="bx bx-git-branch me-1"></i>{step?.label}
                          </span>
                        </div>
                        <p>
                         
                            <span
                              dangerouslySetInnerHTML={{
                                __html: step?.remark.replace(/\n/g, '<br />')
                              }}
                            />
                        </p>
                      </div>
                          )}
                        </>

                      );
                      })
                ) : (
                  <></>
                )}

                {skus.length > 0 && (
                  <div className="mt-2">
                    <h6 className="fw-semibold mb-3 text-muted">SKUs</h6>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {skus.map((sku, idx) => {
                        const product = productInfo.find((p) => p.sku === sku);
                        return (
                          <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: '1px solid #e9ecef', borderRadius: 10, padding: '10px 14px' }}>
                            {product?.image ? (
                              <img src={product.image} alt={product.name} width={48} height={48}
                                style={{ objectFit: 'cover', borderRadius: 8, flexShrink: 0, border: '1px solid #eee' }} />
                            ) : (
                              <div style={{ width: 48, height: 48, flexShrink: 0, background: '#f0f0f0', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <i className="bx bx-package text-muted" style={{ fontSize: 20 }}></i>
                              </div>
                            )}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              {product?.name && (
                                <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.4, marginBottom: 4 }}>{product.name}</div>
                              )}
                              <span className="badge bg-dark" style={{ fontSize: 11, padding: '4px 8px' }}>{sku}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </Col>
            {/* Right Panel */}
            <Col md="3">
              <div className="p-4 pe-0">
                <h4 className="fw-semibold mb-3">Uploaded Images</h4>
                <div className="d-flex flex-wrap gap-2">
                  {images.length > 0 ? (
                    images.map((imgUrl, idx) => (
                      <div
                        key={idx}
                        className="bg-light border border-1 border-secondary-subtle rounded"
                        style={{
                          width: '80px',
                          height: '80px',
                        }}
                      >
                        <img
                          src={imgUrl}
                          width={100}
                          height={100}
                          alt={`Uploaded ${idx + 1}`}
                          style={{ cursor: 'pointer' }}
                          onClick={() => openLightbox(idx)}
                        />
                      </div>
                    ))
                  ) : (
                    <span style={{ color: '#999' }}>No images uploaded.</span>
                  )}
                  {isLightboxOpen && (
                    <Lightbox
                      mainSrc={images[lightboxIndex]}
                      nextSrc={images[(lightboxIndex + 1) % images.length]}
                      prevSrc={images[(lightboxIndex + images.length - 1) % images.length]}
                      onCloseRequest={closeLightbox}
                      onMovePrevRequest={movePrev}
                      onMoveNextRequest={moveNext}
                      imageTitle={`Uploaded ${lightboxIndex + 1}`}
                    />
                  )}
                </div>
              </div>

              {complaintDetailData?.complaintRemark && (
                <div className="p-4 pe-0">
                  <h4 className="fw-semibold mb-2">Remarks</h4>
                  <p className="text-muted mb-0" dangerouslySetInnerHTML={{ __html: complaintDetailData.complaintRemark.replace(/\n/g, '<br />') }} />
                </div>
              )}

                   {(complaintDetailData?.statusText === 'Rejected' || complaintDetailData?.statusText === 'Resolved')  ?  (
                    <></>
                   ) : (
                    <div className="p-4 pe-0">
                      <h4>Remarks</h4>
                      <form
                        onSubmit={async (e) => {
                          e.preventDefault();
                          setStatusError('');
                          setCommentError('');
                          let hasError = false;
                          if (!selectedStatus) {
                            setStatusError('Please select a status.');
                            hasError = true;
                          }
                          if (!comment.trim()) {
                            setCommentError('Please enter a comment.');
                            hasError = true;
                          }
                          if (hasError) return;
                          setIsSubmitting(true);
                          try {
                            await updateComplaintStatus({
                              complaint_no: complaintDetailData?.complaintNo,
                              status: typeof selectedStatus === 'object' ? selectedStatus.value : selectedStatus,
                              remark: comment,
                              updated_by: users?.user_name,
                              dispatch,
                            });
                            setStatusError('');
                            setSelectedStatus('');
                            setComment('');
                            setCommentError('');
                            toast.success('Complaint status updated successfully.');
                            // Refresh complaint details after successful update
                            await getComplaintDetails({
                              params: { complaint_no: complaintDetailData?.complaintNo },
                              dispatch,
                            });
                          } catch (err) {
                            setStatusError('');
                            setCommentError('Failed to update status.');
                          }
                          setIsSubmitting(false);
                        }}
                      >
                        <div className="d-flex flex-wrap gap-3 w-100">
                          <FormGroup className="w-100">
                            <Label>Status*</Label>
                            <select
                              className="form-control form-select "
                              id="choices-single-no-search"
                              value={selectedStatus}
                              onChange={e => setSelectedStatus(e.target.value)}
                              disabled={isSubmitting}
                            >
                              <option value="">Select</option>
                              {remarksOptions.map((option, idx) => (
                                <option key={idx} value={option.label}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            {statusError && (
                              <div style={{ color: 'red', marginTop: '5px' }}>{statusError}</div>
                            )}
                          </FormGroup>
                          <FormGroup className="w-100">
                            <Label>Comment*</Label>
                            <TextArea
                              className="form-control form-textArea"
                              value={comment}
                              onChange={e => setComment(e.target.value)}
                              disabled={isSubmitting}
                            ></TextArea>
                            {commentError && (
                              <div style={{ color: 'red', marginTop: '5px' }}>{commentError}</div>
                            )}
                          </FormGroup>
                          <Button
                            color="success"
                            size="md"
                            className="ms-auto"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                          </Button>
                        </div>
                      </form>
                    </div>
                    )}

                    {isRated === true ? (
                    <div className="p-4 pe-0">
                      <h4 className="fw-semibold mb-3">Customer Rating</h4>
                      <div className="d-flex flex-wrap gap-2 align-items-center mb-2">
                        {/* Show stars for rating */}
                        {(() => {
                          const rating = Number(ratingInfo?.rating) || 0;
                          const maxStars = 5;
                          return (
                            <>
                              {[...Array(maxStars)].map((_, idx) => (
                                <span key={idx} style={{ color: idx < rating ? '#ffc107' : '#e4e5e9', fontSize: '1.5rem' }}>&#9733;</span>
                              ))}
                              <span className="ms-2 fw-semibold">{rating}/5</span>
                            </>
                          );
                        })()}
                      </div>
                      {/* Show rating remark if available */}
                      {ratingInfo?.ratingRemark && (
                        <div className="mt-2 text-muted">{ratingInfo.ratingRemark}</div>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
            </Col>
          </Row>
          {/* <ReturnOrderDetails  orderData={orderData} itemData={itemData}/>  */}
        </Container>
        <Toaster position="top-right" reverseOrder={false} />
      </div>
    </>
  );
};

export default ComplaintDetails;
